/* eslint-disable */
export default {
  copyToClipboard: 'In Zwischenablage kopieren',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
